import axios from 'axios'
axios.defaults.baseURL = process.env.VUE_APP_ROOT_API;

export const state = {
  currentUser: getSavedState('auth.currentUser'),
}

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue
    saveState('auth.currentUser', newValue)
    setDefaultAuthHeaders(state)
  },
}

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return state.currentUser != null
  },
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
    dispatch('validate')
  },

  // Logs in the current user.
  logIn({ commit, dispatch, getters }, { username, password } = {}) {
    if (getters.loggedIn) return dispatch('validate')

    return axios
      .post('oauth/token?grant_type=password', null, {
        params: {
          username: username,
          password: password,
          'grant_type': 'password',
        },
        headers: { "Content-Type": "application/json" },
        auth: {
          username: 'root@pedomantut.com',
          password: 'jhakdligaot23uv3'
        }
      })
      .then((response) => {
        const data = response.data
        commit('SET_CURRENT_USER', data)
        return data
      }).catch((error) => {
        if(error.response.status == 401){
          axios.defaults.headers.common.Authorization = '';
        }
        if(error.response.status == 400){
          axios.defaults.headers.common.Authorization = '';
        }
        return error.response.data;
      })
  },

  // Logs out the current user.
  logOut({ commit }) {
    console.log('LOGOUT.......');
    saveState('auth.currentUser', null)
    commit('SET_CURRENT_USER', null)
  },

  // register the user
  register({ commit, dispatch, getters }, { firstName, lastName, email, username, password } = {}) {
    if (getters.loggedIn) return dispatch('validate')

    return axios
      .post('user/registration', { firstName, lastName, email, username, password })
      .then((response) => {
        const user = response.data
        return user
      })
  },

  // register the user
  resetPassword({ commit, dispatch, getters }, { email } = {}) {
    if (getters.loggedIn) return dispatch('validate')

    return axios.post('/api/reset', { email }).then((response) => {
      const message = response.data
      return message
    })
  },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  validate({ commit, state }) {
    if (state.currentUser == null) return Promise.resolve(null)

    return axios
      .get('user/profile')
      .then((response) => {
        //const user = response.data.data
        //commit('SET_CURRENT_USER', user)
        return true
      })
      .catch((error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 400)) {
          commit('SET_CURRENT_USER', null)
        }
        return false
      })

    //if (state.currentUser == null) return Promise.resolve(null)
    //return true;
    // if (state.currentUser == null) return Promise.resolve(null)
    // return null
  },
}

// ===
// Private helpers
// ===

function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}

function setDefaultAuthHeaders(state) {
  if(state.currentUser != null){
    console.log('AUTH TOKEN FOUND');
    // console.log(state.currentUser);
    // console.log(state.currentUser.access_token);
    // commit('SET_CURRENT_USER', null)
    axios.defaults.headers.common.Authorization = "Bearer "+ state.currentUser.access_token
  }
}
